import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ content }) {
    const athlete = content.athlete;
    const items = [
        "CLASS OF " + athlete.graduationYear,
        "132 LB CURRENT",
        "136 LB PROJECTED",
        "3.2 GPA",
        athlete.height,
        "3 YRS VARSITY",
        "4 YRS WRESTLING",
        "CORINTH HOLDERS HS",
        "CAPITAL CITY WC",
        "WENDELL / NC",
        "ACTIVELY RECRUITING",
    ];
    return (
        <div className="border-y border-white/10 py-5 md:py-6 bg-black overflow-hidden">
            <Marquee gradient={false} speed={35} pauseOnHover>
                {items.map((t, i) => (
                    <span
                        key={i}
                        className="font-mono text-2xl md:text-4xl uppercase tracking-tight px-8 md:px-14 whitespace-nowrap"
                    >
                        {t}
                        <span className="inline-block mx-6 md:mx-10 text-brand-gold">✦</span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
